var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center",attrs:{"fluid":"","fill-height":""}},[_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-img',{staticClass:"mb-5",attrs:{"src":_vm.loader,"width":"200px","contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }